import React, { Fragment, useEffect, useState } from "react";
import { Card, CardBody, Badge, CustomInput, Button } from "reactstrap";
import { NavLink } from "react-router-dom";
import parse from "html-react-parser";
import no_image from '../../../../../../assets/no_image.png';
import { Colxx } from "../../../../../../components/common/CustomBootstrap";
import MessengerFormButton from "./MessengerFormButton";

const MessengerListItem = ({ item, toggleModal, productCategorydata, isHostedPage, isServiceOrder, allAddonCategoryData, allMembershipGroupData, LoadData, languageCode }) => {
  const [categoryColor, setCategoryColor] = useState([]);
  function generateRandomColor() {
    var arr = [
      'primary',
      'secondary',
      'info',
      'success',
      'warning',
      'danger',
      'light',
      'dark',
    ];
    return arr[Math.floor(Math.random() * arr.length)];
  }
  function generateRandomColorCategory(category) {
    var arr = [
      'primary',
      'secondary',
      'info',
      'success',
      'warning',
      'danger',
      'light',
      'dark',
      'orange',
      'blue',
      'violet',
      'light-red',
      'sky-blue',
      'outline-primary',
      'outline-secondary',
      'outline-info',
      'outline-success',
      'outline-warning',
      'outline-danger',
      'outline-light',
      'outline-dark',
    ];
    return arr[category];
  }
  const GetTypes = (text) => {
    var result = text;
    if (text === "ServiceActivity") {
      result = "Information & Action"
    }
    else if (text === "InformationOnly") {
      result = "Information Only"
    }
    else if (text === "aivaVoucher") {
      result = "aiva Voucher"
    }
    else if (text === "RoomService") {
      result = "Room Service"
    }
    else if (text === "OpenChatbot") {
      result = "Open Chatbot"
    }
    else if (text === "OpenRooms") {
      result = "Open Rooms"
    }
    else if (text === "OpenProducts") {
      result = "Open Products"
    }
    else if (text === "TitleAction") {
      result = "Action Only"
    }
    return result;
  }
  useEffect(() => {
    var cate = [];
    allAddonCategoryData.map((item, i) => {
      cate.push({
        label: item.id,
        color: generateRandomColorCategory(i)
      })
    });
    setCategoryColor(cate);
  }, [item, allAddonCategoryData]);

  const getLocalStatement = (statements) => {
    if (statements !== undefined && statements.length > 0) {
      const index = statements.findIndex((m) => m.languageCode === languageCode);
      if (index === -1) {
        const englishIndex = statements.findIndex(
          (m) => m.languageCode === 'en'
        );
        if (englishIndex !== -1) {
          return statements[englishIndex].statement;
        }
      } else {
        return statements[index].statement;
      }
    } else {
      return '';
    }
  };
  return (
    <Colxx xxs="12">
      <Card className="d-flex flex-row mb-3">
        <div className="pl-0 d-flex flex-grow-1 min-width-zero col-2">
          <img
            alt="Thumbnail"
            src={
              item.imageLink != ""
                ? item.imageLink
                : no_image
            }
            className="list-thumbnail responsive border-0 "
          />
          <Badge
            key={0}
            className="position-absolute badge-top-left"
            color={generateRandomColor()}
            pill
          >
            {item.isGlobal ? "Global" : "Property"}
          </Badge></div>
        <div className="pl-2 d-flex flex-grow-1 min-width-zero col-10">
          <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
            <p className="mb-1  text-small w-15 w-sm-100">
              <b>{item.title}</b>
            </p>
            <p className="mb-1  text-small w-15 w-sm-100">
              <b>{GetTypes(item.type)}</b>
            </p>
            <div className="mb-1 text-muted text-small w-20 w-sm-100">
              {parse(item.displayText.length > 50 ? item.displayText.substring(0, 50) + " ..." : item.displayText)}
            </div>
            <p className="mb-1 text-muted text-small w-15 w-sm-100 text-center">
              {item.categoryId !== undefined && item.categoryId !== null &&
                item.categoryId.length > 0 && item.categoryId.map((cat) => (
                  <Fragment>
                    <Badge
                      color={categoryColor.length > 0 &&
                        categoryColor.filter(i => i.label === cat.id).map((e) => e.color)} className="mt-1 mr-1">
                      {allAddonCategoryData.filter(j => j.id === cat.id).map(elem => elem.title)}
                    </Badge>
                  </Fragment>
                ))}
            </p>
            {/* <p className="mb-1 text-muted text-small w-10 w-sm-100">
              {item.priceRangeEnd > 0
                ? <Fragment>
                  {item.currency} {item.priceRangeStart} - {item.currency} {item.priceRangeEnd}
                </Fragment>
                : <Fragment>  {item.currency} {item.priceRangeStart}</Fragment>
              }

            </p> */}
            <p className="mb-1 text-muted text-small w-10 w-sm-100">
              {item.status}
            </p>
            <div className="w-10 w-sm-100">
              <MessengerFormButton
                id={item.id}
                isHostedPage={isHostedPage}
                isServiceOrder={isServiceOrder}
                allAddonCategoryData={allAddonCategoryData}
                allMembershipGroupData={allMembershipGroupData}
                LoadData={LoadData}
                languageCode={languageCode}
                productCategorydata={productCategorydata}
              >
              </MessengerFormButton>
            </div>
          </div>
        </div>
      </Card>
    </Colxx>
  );
};

export default React.memo(MessengerListItem);
